import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import WOW from 'wowjs';
import { FaAngleUp } from "react-icons/fa";

//Pages
import HomeDefault from "./pages/HomeDefault";
import HomeTwo from "./pages/HomeTwo";
import Term from "./pages/Term";
import HomeThree from "./pages/HomeThree";
import About from "./pages/About";
import ListingsOne from "./pages/ListingsOne";
import ListingsTwo from "./pages/ListingsTwo";
import ListingsThree from "./pages/ListingsThree";
import ListingsDetails from "./pages/ListingsDetails";
import Categories from "./pages/Categories";
import Visited from "./pages/Visited";
import Team from "./pages/Team";
import TeamDetails from "./pages/TeamDetails";
import Blog from "./pages/Blog";
import BlogDetails from "./pages/BlogDetails";
import BussinessDetail from "./pages/BussinessDetail";
import Contact from "./pages/Contact";
import Error from "./pages/Error";
import ScrollToTopRoute from './components/scroll-to-top-route/ScrollToTopRoute';

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';

function App() {
  useEffect(() => {
    new WOW.WOW({
        live: false
      }).init();
    }, []
  );
  return (
    <Router>
      <ScrollToTopRoute />
        <Routes>
            <Route path="/" element={<HomeDefault />} />
            <Route path="/bussiness/detail" element={<BussinessDetail />} />
            <Route path="/home-two" element={<HomeTwo />} />
            <Route path="/term" element={<Term />} />
            <Route path="/home-three" element={<HomeThree />} />
            <Route path="/about" element={<About />} />
            <Route path="/listings1" element={<ListingsOne />} />
            <Route path="/listings2" element={<ListingsTwo />} />
            <Route path="/listings3" element={<ListingsThree />} />
            <Route path="/listings-details" element={<ListingsDetails />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/visited" element={<Visited />} />
            <Route path="/team" element={<Team />} />
            <Route path="/team-details" element={<TeamDetails />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog-details" element={<BlogDetails />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Error />} />
        </Routes>
        <ScrollToTop className="scrollUp" smooth top="1500" component={<FaAngleUp />} />
    </Router>
  );
}

export default App;
